export const successMessageCreate = 'Role added successfully.'
export const successMessageUpdate = 'Role updated successfully.'

export const errorMessageCreate = 'Failed to add role.'
export const errorMessageUpdate = 'Failed to update role.'
